import { createSlice } from "@reduxjs/toolkit";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface MenusState {
  menusData: {};
}

const initialState: MenusState = {
  menusData: {},
};

export const menusSlice = createSlice({
  name: "menus",
  initialState,
  reducers: {
    getAllMenusData: (state) => {},
    saveAllMenusData: (state, actions) => {
      state.menusData = actions.payload
        ? convertArrayToObject(actions.payload, "mid")
        : {};
    },
    deleteMenuData: (state, actions) => {},
    saveMenuData: (state, actions) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllMenusData,
  saveAllMenusData,
  deleteMenuData,
  saveMenuData,
} = menusSlice.actions;
export default menusSlice.reducer;
